// extracted by mini-css-extract-plugin
export default {"replace-color":"fyA9P8D___replace-color","replaceColor":"fyA9P8D___replace-color","item":"EZmZGsw___item"};